import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './CaseStudies.css';

const CaseStudies = () => {
  // 模拟案例数据
  const caseStudies = [
    {
      id: 1,
      title: "大型基建集团多项目协同管理",
      client: "某大型基建集团",
      industry: "市政工程",
      logo: "[客户Logo]",
      overview: "实现多项目成本穿透式管理，审批效率提升40%",
      challenge: "该集团同时管理20+个大型基建项目，面临成本数据滞后、合同管理分散、多项目协同困难等挑战，难以实现有效的项目监控和决策支持，导致项目延期风险高、成本超支频发。",
      solution: "通过部署星晟工程管控系统，实现了项目全周期透明化管理，打通了进度、成本、合同等关键环节，建立了统一的多项目协同管理平台，提供了实时的数据洞察和智能预警机制，让管理层能够实时掌握所有项目的运营状况。",
      results: [
        { label: "审批效率提升", value: "40%" },
        { label: "成本核算周期缩短", value: "50%" },
        { label: "合同履约风险降低", value: "30%" },
        { label: "项目延期率降低", value: "25%" }
      ],
      testimonial: "星晟的系统帮助我们第一次真正看清了所有项目的实时成本和进度，实现了从'拍脑袋决策'到'数据驱动决策'的转变，这是革命性的改变。现在我们可以提前发现风险，及时调整策略，项目成功率大幅提升。",
      author: "项目总监, 张先生",
      company: "某大型基建集团"
    },
    {
      id: 2,
      title: "房地产开发商多项目资金管控",
      client: "知名房地产开发商",
      industry: "房地产",
      logo: "[客户Logo]",
      overview: "实现多项目资金统一管理，资金使用效率提升35%",
      challenge: "企业在同时开发15+个房地产项目时，资金使用效率低，难以实现统一的成本控制和资金调配，经常出现资金闲置或资金紧张的情况，影响项目进度和盈利能力。财务数据滞后，无法及时为决策提供支持。",
      solution: "引入星晟工程管控系统的成本资金看板功能，实现了对所有项目的实时资金监控和穿透式管理，建立了统一的资金池管理机制，支持多项目资金灵活调配，实现了从月度财务报告到实时财务监控的转变。",
      results: [
        { label: "资金使用效率提升", value: "35%" },
        { label: "项目利润率提高", value: "12%" },
        { label: "财务报告时效性", value: "从月度提升至实时" },
        { label: "资金成本降低", value: "18%" }
      ],
      testimonial: "星晟的解决方案让我们能够精准掌控每个项目的资金流向，实现了资金的优化配置，大大提升了我们的财务管理效率和盈利能力。现在我们可以实时了解每个项目的财务状况，及时调整资金策略，避免了资金浪费和项目风险。",
      author: "财务总监, 李女士",
      company: "知名房地产开发商"
    },
    {
      id: 3,
      title: "市政工程项目全流程数字化管理",
      client: "某市政工程项目",
      industry: "市政工程",
      logo: "[客户Logo]",
      overview: "实现项目进度100%在线透明，跨部门协作效率提升45%",
      challenge: "市政工程项目涉及10+个部门和20+个承包商，进度信息不透明，协调困难，数据上报不及时，经常出现信息不对称导致的进度延误和质量问题，项目监管难度大。",
      solution: "采用星晟工程管控系统的项目一体化管理模块，实现了项目进度的全流程在线管理和实时监控，建立了统一的项目协同平台，所有参与方可以实时查看项目进度、提交数据、协同工作，实现了项目管理的数字化转型。",
      results: [
        { label: "项目进度透明度", value: "100%" },
        { label: "数据上报及时率", value: "98%" },
        { label: "跨部门协作效率", value: "提升45%" },
        { label: "项目延期率降低", value: "30%" }
      ],
      testimonial: "通过星晟的系统，我们实现了项目管理的数字化转型，各部门之间的协作变得更加高效顺畅。现在所有参与方都能实时了解项目进展，问题能够及时发现和解决，项目质量和进度都得到了显著提升。",
      author: "项目经理, 王先生",
      company: "某市政工程项目"
    }
  ];

  const heroStats = [
    { label: "项目效率平均提升", value: "40%+" },
    { label: "成本控制精度提升", value: "50%" },
    { label: "履约风险降低", value: "30%" },
    { label: "上线企业", value: "200+ 家" }
  ];

  const impactHighlights = [
    { title: "多项目协同", description: "跨区域、跨团队的工程集团可实现统一调度、统一监控，决策效率显著提升" },
    { title: "穿透式资金管理", description: "实时掌握资金流向，与财务系统打通，实现从预算到执行的全程可视" },
    { title: "风险智能预警", description: "合同、进度、资金等关键指标自动预警，提前化解超支与延期风险" }
  ];

  const featuredCase = caseStudies[0];

  return (
    <div className="case-studies">
      <motion.section
        className="hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.p
            className="eyebrow"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            CUSTOMER SUCCESS
          </motion.p>
          <motion.h1
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            数智化工程管控，正在改变行业龙头的运营方式
          </motion.h1>
          <motion.p
            className="intro"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            数百家工程企业通过星晟工程管控系统构建可视、可控、可预测的数字底座。我们陪伴客户完成从单点工具到全链路协同的升级，让每一次投资都可评估、每一个节点都有数据支撑。
          </motion.p>
          <motion.div
            className="hero-stats"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.5 }}
          >
            {heroStats.map((stat, index) => (
              <motion.div
                className="hero-stat-card"
                key={stat.label}
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.6 + index * 0.1 }}
              >
                <span className="value">{stat.value}</span>
                <span className="label">{stat.label}</span>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </motion.section>

      <motion.section
        className="featured-case"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <div className="featured-content">
            <motion.div
              className="featured-summary"
              initial={{ x: -30, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <p className="eyebrow">重点案例</p>
              <h2>{featuredCase.title}</h2>
              <p className="client-meta">{featuredCase.client} · {featuredCase.industry}</p>
              <p className="challenge">{featuredCase.challenge}</p>
              <div className="solution-card">
                <h3>解决方案</h3>
                <p>{featuredCase.solution}</p>
              </div>
            </motion.div>
            <motion.div
              className="featured-results"
              initial={{ x: 30, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <h4>关键成果</h4>
              <div className="featured-results-grid">
                {featuredCase.results.map((result, index) => (
                  <motion.div
                    className="result-item"
                    key={result.label}
                    initial={{ y: 20, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.4 + index * 0.1 }}
                  >
                    <span className="result-value">{result.value}</span>
                    <span className="result-label">{result.label}</span>
                  </motion.div>
                ))}
              </div>
              <div className="featured-testimonial">
                <p className="quote" style={{ color: 'rgba(255, 255, 255, 0.9)' }}>“{featuredCase.testimonial}”</p>
                <p className="author">— {featuredCase.author} · {featuredCase.company}</p>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.section>

      <motion.section
        className="case-impact"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <div className="impact-grid">
            {impactHighlights.map((item, index) => (
              <motion.div
                className="impact-card"
                key={item.title}
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 * index }}
              >
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      <motion.section
        className="cases-showcase"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <div className="section-header">
            <motion.p
              className="eyebrow"
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              行业落地
            </motion.p>
            <motion.h2
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              面向不同类型工程企业的落地范式
            </motion.h2>
            <motion.p
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              我们与客户共同搭建全生命周期的工程数字化平台，从立项、招采、合同到资金，形成一套可复制、可扩展的成功模型。
            </motion.p>
          </div>
          <div className="cases-grid">
            {caseStudies.map((caseStudy, index) => (
              <motion.div
                key={caseStudy.id}
                className="case-card"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 * index }}
              >
                <div className="case-meta">
                  <span>{caseStudy.client}</span>
                  <span>{caseStudy.industry}</span>
                </div>
                <h3>{caseStudy.title}</h3>
                <p className="case-overview">{caseStudy.overview}</p>
                <p className="case-detail">{caseStudy.challenge}</p>
                <Link to={`/case-studies/${caseStudy.id}`} className="link-button">查看完整方案 →</Link>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      <motion.section
        className="testimonials"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <div className="section-header">
            <motion.p
              className="eyebrow"
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              客户评价
            </motion.p>
            <motion.h2
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              听听他们怎么说
            </motion.h2>
          </div>
          <div className="testimonial-grid">
            {caseStudies.map((caseStudy, index) => (
              <motion.div
                className="testimonial-card"
                key={caseStudy.id}
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 * index }}
              >
                <p className="quote">“{caseStudy.testimonial}”</p>
                <div className="testimonial-meta">
                  <span className="name">{caseStudy.author}</span>
                  <span className="company">{caseStudy.company}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      <motion.section
        className="case-cta"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.p
            className="eyebrow"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            下一步行动
          </motion.p>
          <motion.h2
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            把客户的成功方法复制到你的团队
          </motion.h2>
          <motion.p
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            预约顾问演示，获得行业专属评估报告与落地路线图，让工程管理真正“看得见、控得住、算得清”。
          </motion.p>
          <motion.div
            className="cta-buttons"
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <a href="/product" className="primary-button">预约产品演示</a>
            <a href="/contact" className="secondary-button">联系行业顾问</a>
          </motion.div>
        </div>
      </motion.section>
    </div>
  );
};

export default CaseStudies;